export const selectIsDrawerOpen = state => state.app.drawerOpen;
export const selectAppTitle = state => state.app.appTitle;
export const selectAppNameTitle = state => state.app.appNameTitle;
export const selectAppDecimal = state => state.app.appDecimal;
export const selectBandedRows = state => state.app.bandedRows;
export const selectGridVerticalLines = state => state.app.gridVerticalLines;
export const selectGridFontSize = state => state.app.gridFontSize;
export const selectGridRowHeight = state => state.app.gridRowHeight;
export const selectHideGridSideBar = state => state.app.hideGridSideBar;
export const selectGridHeaderHeight = state => state.app.gridHeaderHeight;
export const selectLoadDataOnLaunch = state => state.app.loadDataOnLaunch;
export const selectGridLevelLabels = state => state.app.gridLevelLabels;
export const selectShowGridLevelCount = state => state.app.showGridLevelCount;
export const selectDefaultExpansion = state => state.app.defaultExpansion;
export const selectListenScenarioAppTalk = (state) =>
    state.app.listenScenarioAppTalk;